import { Box, Card } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useCampaign } from '@/api/campaigns/get'
import { useEducationModuleById } from '@/api/education-modules/module-by-id'
import CardHeader from '@/common/components/Card/CardHeader'
import LoadingContainer from '@/common/components/LoadingContainer/LoadingContainer'
import VideoPreview from '@/common/components/VideoPreview'
import { VideoResult } from '@/types/videos'

type CampaignVideoPreviewParams = { campaignId: string }

const CampaignVideoPreview: FC<CampaignVideoPreviewParams> = ({ campaignId }) => {
  const { t } = useTranslation()
  const { data: campaignData } = useCampaign(campaignId)
  const { data: video, isLoading } = useEducationModuleById(campaignData?.assets[0]._id)

  if (!video || isLoading) {
    return (
      <Card>
        <LoadingContainer />
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader title={t('campaignDashboard.yourVideo.title')} />
      <Box paddingTop={2}>
        <VideoPreview video={video as VideoResult} />
      </Box>
    </Card>
  )
}

export default CampaignVideoPreview
